import type { NoContainerResolverContext } from '@source-components-react/types';
import { resolveEmbed } from './resolve-embed';

/**
 * `false` whenever an iframe is rendered: it is a replaced element that holds
 * margin, padding, width and height on itself, so a wrapper div would only add
 * an element that does nothing.
 *
 * `true` when the URL is missing or the allowlist refused it, because then
 * there is no element at all — the same answer `r-text` gives for bare text.
 * Deciding this from `resolveEmbed`, rather than from the fact that this
 * component "is an iframe component", is what keeps the two in step.
 */
export const resolveNoContainer = ({ componentAttributes }: NoContainerResolverContext): boolean =>
  resolveEmbed(componentAttributes) === null;
